import React from "react";
import invariant from "invariant";
import ExportRequest from "./model";
import { ToastContext } from "@weezevent/nacre";
import { useTranslation } from "react-i18next";

/**
 * Download the pdf
 * @param  {string} url - path of the pdf
 */
export const downloadPDF = (url) => {
	invariant(typeof url === 'string', `invalid ${url}`);

	const request = new XMLHttpRequest();

	request.open("GET", url, true);

	request.responseType = "blob";

	request.onload = () => {
		// Create a fake link to download the file
		const link = document.createElement("a");
		document.body.appendChild(link);
		link.style = "display: none";

		const file = new Blob([request.response], {
			type: "application/pdf"
		});

		// Create the pdf from the url
		const urlPDF = window.URL.createObjectURL(file);

		// Set the data of the pdf inside the anchor
		link.href = urlPDF;
		link.download = url.match("aws.com/((?:.|\n)*?)\\?AWS")[1];
		link.click();

		// Clean objects when user has downloaded his file
		window.URL.revokeObjectURL(urlPDF);
		document.body.removeChild(link);
	};

	request.send();
};

export default function useNotifications() {
	// Trans and Toast notification
	const { success } = React.useContext(ToastContext);
	const { t } = useTranslation();

	const onComplete = React.useCallback((instance) => {
		invariant(instance instanceof ExportRequest, 'instance is required');
		success(
			t([
				"export.export-succeeded",
				"An export has just been generated and it's available inside your downloads."
			])
		);
		// Automatically start the download of the PDF export
		downloadPDF(instance.getDest());
	}, [success, t]);

	const onWatch = React.useCallback((instance) => {
		invariant(instance instanceof ExportRequest, 'instance is required');
		// notify the user of the start of the export
		success(
			t([
				"export.export-launched",
				"Generating export is onloading. A notification will alert you when it will be ready."
			])
		);
	}, [success, t]);

	return { onWatch, onComplete };
}
